import React from 'react';
import '../../style/Carousel.scss';
import { Carousel } from 'react-bootstrap';

function CarouselComponent({ item }) {
  return (
    <Carousel>
      {item.map((el) => (
        <Carousel.Item>
          <img className='d-block w-100' src={el.image} alt='First slide' />
          <Carousel.Caption className='d-none d-lg-block captions'>
            <p>{el.caption}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default CarouselComponent;
